import { useOutletContext, Link } from "react-router-dom";
import { t } from "../i18n";

export default function NotFound() {
  const ctx = useOutletContext();
  const lang = ctx?.lang || "en";
  const i = t[lang];
  return (
    <section className="container-site py-24 md:py-32" data-testid="not-found-page">
      <p className="font-display text-7xl font-extrabold tracking-tighter text-petrol/15">404</p>
      <h1 className="mt-4 font-display text-3xl font-extrabold tracking-tighter sm:text-4xl">{i.notFound.title}</h1>
      <p className="mt-3 max-w-md text-base text-muted-foreground">{i.notFound.sub}</p>
      <Link
        to={`/${lang}`}
        data-testid="not-found-home-link"
        className="mt-8 inline-flex items-center rounded-full bg-petrol px-6 py-3 text-sm font-bold text-white transition-colors duration-200 hover:bg-petrol-dark"
      >
        {i.notFound.cta}
      </Link>
    </section>
  );
}
